import {withRouter} from 'react-router-dom';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import View from './view';

export default withRouter(connect(controller)(View));
